import { LogMode } from "../features/log/logSlice"

export const milesOrPoints = (mode : LogMode, n : number) => {
  if(mode === 'points') {
    if(n <= 1 && n >= 0) {
      return 'point';
    } else {
      return 'points';
    }
  } else {
    if(n <= 1 && n >= 0) {
      return 'mile';
    } else {
      return 'miles';
    }
  }
}